// Add strongly typed properties here

export enum Nomenclatures {
    ITEM_NUMBER = 'Item Number',
    ITEM_NUMBER_SHORT = 'Item #',
    DESCRIPTION = 'Description',
    UNIT_OF_MEASURE = 'Unit Of Measure',
    UNIT_OF_MEASURE_SHORT = 'U-O-M',
    DAYS_SINCE_LAST_ORDERED = 'Days Since Last Ordered',
    DAYS_SINCE_LAST_ORDERED_SHORT = 'Days Last Ord',
    QUANTITY_LAST_ORDERED = 'Quantity Last Ordered',
    QUANTITY_LAST_ORDERED_SHORT = 'Last Qty',
    UNIT_COST = 'Unit Cost',
    QUANTITY = 'Quantity',
    QUANTITY_SHORT = 'Qty',
    CRITICAL = 'Critical',
    COST = 'Cost',
    CASE_PRICE='Case Price',
    STATUS= 'Status',
    PO_NUMBER = 'PO Number',
    SAVED = 'Saved',
    AMOUNT = 'Amount',
    SUGGESTED_QUANTITY = 'Suggested Qty',
    SUGGESTED_QUANTITY_SHORT = 'Sug Qty',
    Suggested = 'Suggested',
    qtySuggested = 'qtySuggested',
    qtyLastOrdered = 'qtyLastOrdered',
    PURCHASE_ORDER = 'Purchase Order',
    MAX_ORDER_QTY = 'Max Order Qty',
    MAX_ORDER_QTY_SHORT = 'Max Qty',
    BUILD_TO_QTY = 'Build-To Qty',
    BUILD_TO_QTY_SHORT = 'Bld Qty',
    SHOW = 'Show',
    SEQUENCE = 'Sequence #',
    SEQUENCE_SHORT = 'Seq #',
    DIALOG_ERROR_MAX_QUANTITY_TITLE = 'Maximum Quantity Exceeded',
    DIALOG_ERROR_MAX_QUANTITY_MESSAGE = 'The quantity entered exceeds maximum order quantity.\n' +
        'Do you want to order this quantity anyway?',
    DIALOG_EXIT_ORDER_TITLE = 'Leaving Order Entry Screen',
    DIALOG_EXIT_ORDER_MESSAGE = 'This will cause your unsaved changes to be lost.',
    DIALOG_CRITICAL_ITEM_WARNING = 'Critical Item Warning!',
    DIALOG_CRITICAL_ITEM_DETECTED_TITLE = 'Critical Items Detected!',
    DIALOG_CRITICAL_ITEM_DETECTED_MESSAGE = 'Your order indicates that there are critical items that have not been ordered.\n' +
        'Would you like to review those critical items?',
    DIALOG_CRITICAL_ITEM_DETECTED_MESSAGE_WEB = 'Your order indicates that there are critical items that have not been ordered. Would you like to review those critical items?',
    DIALOG_ORDER_NOT_SUBMITTED_TITLE = 'Order Not Submitted',
    DIALOG_ORDER_NOT_SUBMITTED_MESSAGE = 'Your order has not been submitted. Please enter a value for quantity before submitting.',
    DIALOG_ORDER_PLACED_MESSAGE = 'Your order has been placed. Please check back in 30 minutes for your confirmation.',
    DIALOG_ORDER_SAVED_TITLE = 'Order Saved',
    DIALOG_ORDER_SAVED_MESSAGE = 'Your order has been saved.',
    DIALOG_ORDER_SAVED_SEND_MESSAGE = 'Your order has been saved. Do you want to send it now?',
    DIALOG_ORDER_NOT_SAVED_TITLE = 'Order Not Saved',
    DIALOG_ORDER_NOT_SAVED_MESSAGE = 'Your order has not been saved. Please enter a value for cases before saving.',
    DIALOG_ORDER_ITEM_INSERT_ERROR_MESSAGE = 'Problem Inserting Items. Please Try Again',
    DIALOG_ORDER_STATUS_ERROR_MESSAGE = 'Problem Setting Error Status',
    DIALOG_ORDER_START_ERROR_MESSAGE = 'Problem Starting Selected Order',
    DIALOG_EVENT_INVALID_TITLE = 'Invalid Selection',
    DIALOG_EVENT_INVALID_MESSAGE = 'Please select an event from today.',
    DIALOG_UNSCHEDULED_ORDER_WARNING_TITLE = 'WARNING!',
    DIALOG_UNSCHEDULED_ORDER_WARNING_MESSAGE = 'The calendar indicates that you have a scheduled order available or have an incomplete order already started. ' +
        'Please return to the calendar and complete the order by selecting the correct day.',
    DIALOG_UNSCHEDULED_ORDER_MESSAGE = 'This option should only be used if your scheduled order date is unavailable.'
        + ' Unscheduled orders may NOT be used for add-ons or to make a correction to a prior order.'
        + ' Any changes must be communicated directly to your regional distribution center.'
        + ' If you are unsure of how to use this option, please contact the SourceLink Support'
        + ' Center toll-free at 1-800-543-3333.',
    TOAST_ORDER_SYNCED = 'Order changes successfully saved.',
    TOAST_ORDER_SAVED = 'Order Saved',
    TOAST_ORDER_SAVING = 'Saving Order',
    TOAST_MAX_QUANTITY = 'Warning, Maximum Quantity Exceeded',
    TOAST_INVALID_QUANTITY = 'The quantity entered may be a key error',
    TOAST_INVALID_NUMBER_TYPE = 'Please Enter a Valid Number',
    TOAST_INVALID_NUMBER_AMOUNT = 'Please Enter a Number from 0-999',
    TOAST_INVALID_ENTRY = 'Invalid Entry',
    TOAST_CATEGORY_ADDED = 'Adding Category ',
    TOAST_CATEGORY_DELETED = 'Deleting Category',
    TOAST_CATEGORY_PLEASE_ENTER_A_CATEGORY = 'Please Enter a Category',
    CATEGORY_ALREADY_EXISTS = 'Category Already Exists. Please Enter a New Category Name!',
    DIALOG_DELETE_CATEGORY = 'Delete Category',
    DIALOG_DELETE_CATEGORY_MSG = 'Are you sure you want to delete ',
    DIALOG_DELETE_INVENTORY_ITEM = 'Delete Item',
    DIALOG_SAVE_PROFILE_ITEMS = 'Save Profile Items',
    DIALOG_SAVE_PROFILE_ITEMS_MSG = 'Are you sure you want to Save Items? ',
    TOAST_TITLE_INVALID_SELECTION = 'Invalid Selection',
    TOAST_DELETE_ERROR = 'Cannot delete CUSTOMIZED LIST',
    TOAST_SELECT_ITEM = 'Please select an item.',
    WARNING = 'Warning',
    ERROR = 'Error',
    TIMEOUT2000 = '2000',
    TIMEOUT4000 = '4000',
    TIMEOUT5000 = '5000',
    TIMEOUT10000 = '10000',
    SAVE_SUCCESSFUL = 'Save Successful',
    DIALOG_COPY_ORDER_TITLE = 'Copy Suggested Order Quantity',
    DIALOG_COPY_ORDER_MESSAGE = 'Do you want to copy the amounts from the Suggested Order\n' + 'Quantity column to the Order Quantity column?',
    NO_INTERNET_CONNECTION = 'No internet connection',
    ORDER_ALREADY_SUBMITTED = 'A order for today has already been submitted. Taking you to the home page now.',
    ORDER_ALREADY_SUBMITTED_TITLE = 'Order Already Submitted'

}
